class NumberUtils {
  formatToCurrency = (value) => {
    if (!value) return value;

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    });

    const str = formatter.format(value);

    return str;
  };
  normalizeCurrency = (string) => {
    if (typeof string !== 'string') {
      return '0';
    }
    return string.replaceAll(/[^0-9.]/g, '');
  };
}

export default NumberUtils;
